module.exports = __webpack_public_path__ + "static/media/EU.bc5055af.png";